import React, { useEffect, useMemo, useState } from 'react';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import add from '@iconify/icons-ic/add';
import { MdSystemUpdateAlt } from 'react-icons/md';
import {
  Box,
  Tooltip,
  IconButton,
  InputAdornment,
  Grid,
  Select,
  MenuItem,
  TextField,
  Typography,
  Autocomplete
} from '@mui/material';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { useNavigate } from 'react-router-dom';
import { RootStyle, SearchStyle } from '../Global/Styling';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
// ----------------------------------------------------------------------

export default function OnBoardingToolbar({
  parent,
  pageMenu,
  filterName,
  setFilterName,
  filterState,
  setFilterState,
  statusOptions = []
}) {
  const [partnerType1, setPartnerType1] = useState('');
  const navigate = useNavigate();

  const [isOpenFilter, openFilter] = useState(false);
  const { CityDrop, LoanTypeDrop, PartnerStatusDrop, SourceDrop } = useGlobalSelector();

  const pageData = useMemo(
    () =>
      pageMenu?.reduce((acc, item) => {
        acc[item?.subPageCode] = item?.isEnable;
        return acc; // important to return the accumulator
      }, {}), // initial value is an empty object
    [pageMenu]
  );

  const handleRemoveFilter = (e) => {
    setFilterState((prev) => ({
      ...prev,
      typeId: null,
      partnerStatusTypeId: null,
      cityId: null,
      pageNumber: 1
    }));
    setFilterName('');
  };

  useEffect(() => {
    if (PartnerStatusDrop) {
      setPartnerType1(PartnerStatusDrop?.[0]?.value);
    }
  }, [PartnerStatusDrop]);

  return (
    <>
      {/* {console.log('sss StatusDrop', StatusDrop)} */}
      {isOpenFilter && (
        <Box px={3} pt={2}>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <Box mb={3}>
                <Select
                  fullWidth
                  inputProps={{
                    className: 'textInput'
                  }}
                  value={filterState?.typeId ?? ' '}
                  onChange={(e) => {
                    const val = e.target.value === ' ' ? null : e.target.value;
                    setFilterState((prev) => ({ ...prev, typeId: val, pageNumber: 1 }));
                  }}
                >
                  <MenuItem value=" " disabled>
                    Select Partner Type
                  </MenuItem>
                  {PartnerStatusDrop?.length > 0 &&
                    PartnerStatusDrop?.map((item) => (
                      <MenuItem value={item?.value} key={item?.value}>
                        {item?.label}
                      </MenuItem>
                    ))}
                </Select>
              </Box>
            </Grid>

            <Grid item xs>
              <Autocomplete
                disablePortal
                id="combo-box-demo8"
                size="small"
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select City" />
                )}
                value={filterState?.city ?? null}
                options={CityDrop || []}
                getOptionLabel={(option) => option.label || ''}
                renderOption={(props, option) => <li {...props}>{option.label}</li>}
                onChange={(e, newValue) => {
                  setFilterState((prev) => ({
                    ...prev,
                    city: newValue ?? null,
                    cityId: newValue ? newValue.value : null,
                    pageNumber: 1
                  }));
                }}
              />
            </Grid>

            <Grid item xs>
              <Select
                fullWidth
                onChange={(e) => {
                  const val = e.target.value === ' ' ? null : e.target.value;
                  setFilterState((prev) => ({
                    ...prev,
                    partnerStatusTypeId: val,
                    pageNumber: 1
                  }));
                }}
                value={filterState?.partnerStatusTypeId ?? ' '}
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterState.status}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Status
                </MenuItem>

                {statusOptions?.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item xs="auto">
              <Tooltip title="Reset Filter">
                <IconButton
                  sx={{ padding: '0', paddingTop: '0.4rem', paddingBottom: '0.4rem' }}
                  onClick={handleRemoveFilter}
                >
                  <FilterListOffIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )}
      <RootStyle
        sx={{
          minHeight: 45,
          borderBottom: '1px solid #eaedf1'
        }}
      >
        <Box>
          {console.log('sss pageData', pageData)}
          {pageData?.ADD_NEW && (
            <Tooltip title="Add New" placement="top" arrow>
              <span>
                <IconButton className="squareIconButton" onClick={() => navigate(`/${parent}/add`)}>
                  <Icon icon={add} width={18} />
                </IconButton>
              </span>
            </Tooltip>
          )}
          &nbsp;&nbsp;&nbsp;
          {/* {pageData?.EXPORT_DATA && (
            <Tooltip title="Export data" placement="top" arrow>
              <span>
                <IconButton className="squareIconButton">
                  <MdSystemUpdateAlt size={18} />
                </IconButton>
              </span>
            </Tooltip>
          )} */}
          &nbsp;&nbsp;&nbsp;
        </Box>

        <Box>
          {pageData?.SEARCH && (
            <>
              <SearchStyle
                value={filterName}
                onChange={(e) => {
                  setFilterName(e.target.value);
                }}
                placeholder="Search OnBoarding"
                classes={{
                  root: 'searchHolder',
                  input: 'searchInput'
                }}
                startAdornment={
                  <InputAdornment position="start">
                    <Box component={Icon} icon={searchFill} />
                  </InputAdornment>
                }
              />

              <Tooltip title="Filter list">
                <IconButton onClick={() => openFilter((prev) => !prev)}>
                  <Icon icon={roundFilterList} />
                </IconButton>
              </Tooltip>
            </>
          )}
        </Box>
      </RootStyle>
    </>
  );
}
